import { render, staticRenderFns } from "./CChartDoughnutExample.vue?vue&type=template&id=307b63e8&"
import script from "./CChartDoughnutExample.vue?vue&type=script&lang=js&"
export * from "./CChartDoughnutExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports